import React, { forwardRef, useEffect, useState } from 'react';

import { ErrorText, Icon } from 'common-ui/input/Input.styles';
import errorIcon from 'common-ui/input/assets/error.svg';
import Tooltip from 'common-ui/tooltip';
import PropTypes from 'prop-types';

import {
  CharacterCount,
  TextAreaField,
  TextAreaLabel,
  TextAreaWrapper,
} from './TextArea.styles';

const TextArea = forwardRef(
  (
    {
      label,
      error,
      value,
      onChange,
      placeholder,
      resizeVertical = true,
      resizeHorizontal = false,
      minLength,
      maxLength = 100,
      req,
      tooltip,
      ...props
    },
    ref
  ) => {
    const [textAreaValue, setTextAreaValue] = useState(value || '');

    useEffect(() => {
      setTextAreaValue(value || '');
    }, [value]);

    const handleChange = (event) => {
      setTextAreaValue(event.target.value);
      if (onChange) {
        onChange(event);
      }
    };

    return (
      <TextAreaWrapper>
        {label && (
          <TextAreaLabel>
            {label}
            {req && <span>*</span>}
            {tooltip && <Tooltip text={tooltip} />}
          </TextAreaLabel>
        )}
        <TextAreaField
          ref={ref}
          $error={error}
          value={textAreaValue}
          onChange={handleChange}
          placeholder={placeholder || 'Type your text...'}
          $resizeVertical={resizeVertical}
          $resizeHorizontal={resizeHorizontal}
          minLength={minLength}
          maxLength={maxLength}
          className="text-area-field"
          {...props}
        />
        <CharacterCount>
          {textAreaValue?.length}-{maxLength} characters
        </CharacterCount>
        {error?.length && (
          <ErrorText>
            <Icon src={errorIcon} alt="error" />
            {error}
          </ErrorText>
        )}
      </TextAreaWrapper>
    );
  }
);

TextArea.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  resizeVertical: PropTypes.bool,
  resizeHorizontal: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
};

TextArea.defaultProps = {
  label: '',
  value: '',
  onChange: () => {},
  placeholder: '...',
  resizeVertical: false,
  resizeHorizontal: true,
};

export default TextArea;
